import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BonusdetailPage } from './bonusdetail';

@NgModule({
  declarations: [
    BonusdetailPage,
  ],
  imports: [
    IonicPageModule.forChild(BonusdetailPage),
  ],
})
export class BonusdetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/bonusdetail/bonusdetail.module.ts